import { oneMinuteListLoad, powerDailySubmit } from '../../../api/oneminute'

let powerDailyDone = 0 // 标识是否已提交草根值

export default {
  async load({ state }) {
    await oneMinuteListLoad({}).then((R) => {
      state.audioList = R.list || []
    })
    return state.audioList || []
  },

  play({ commit }, { oid }) {
    commit('play', { oid })
    if (!powerDailyDone) {
      powerDailyDone = 1
      powerDailySubmit({
        type: 16,
        //objId   :	'' //string	对象id 需要做标志计数的数据的id ，默认 ''
        des: '播放一分钟' //string	自定义描述 ，默认 ''
      })
    }
  }
}
